export type Data = {
  set: (param: any) => void;
  get: () => void;
}

export const BusinessKey: Storage = {
  setItem: (key: string, state: any) => {
    return window.localStorage.setItem(key, btoa(JSON.stringify(state)));
  },
  getItem(key: string) {
    const state = window.localStorage.getItem(key);
    if (state) {
      try {
        return JSON.parse(atob(state));
      } catch (error) {
        return null;
      }
    }
    return null;
  },
  length: 0,
  clear: function (): void {
    window.localStorage.clear();
  },
  key: function (index: number): string {
    return window.localStorage.key(index) || '';
  },
  removeItem: function (key: string): void {
    throw localStorage.removeItem(key);
  }
}